import { Table as TableCore, TableHeader } from "@tiptap/extension-table";
import { TableCellBackground } from "./cell-background";
import { TableCell } from "./components/TableCell";
import { TableRow } from "./components/TableRow";
import type { TableOptions } from "./types";

export const Table = /* @__PURE__ */ TableCore.extend<TableOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        style: `      
          border-collapse: collapse;     
          width: 100%;
        `,
        class: "advanced-table",
      },
    };
  },

  addExtensions() {
    return [
      TableRow.configure(this.options.tableRow),
      TableHeader.configure(this.options.tableHeader),
      TableCell.configure(this.options.tableCell),
      TableCellBackground.configure(this.options.tableCellBackground),
    ];
  },
});
